import Popover from ".";
import Button from "../Button";
import Grid from "../Grid";
import GridItem from "../GridItem";


export default function PopoverConfirm({children, text, onConfirm, onCancel, className = 'w-[200px]', ...props}) {
    return (
        <Popover {...props} overlay title={false} buttonAs="span" handler={children}>
            {({close}) => (
                <Grid className={className} space="m" col>
                    <GridItem grow>
                        {text || 'confirmAction'}
                    </GridItem>
                    <Grid justify="end" items="center" space="m">
                        <Button variant="pr" size="m2" onClick={() => {
                            close();
                            onConfirm?.()
                        }}>
                            {'confirm'}
                        </Button>
                        <Button size="m2" onClick={() => {
                            close();
                            onCancel?.()
                        }}>
                            {'cancel'}
                        </Button>
                    </Grid>
                </Grid>
            )}
        </Popover>
    )
}